export default {
  CPP: {
    '1': 6,
    '1.1': 6,
    '1.2': 7,
    '1.3': 7,
    '1.4': 8,
    '2': 9,
    '2.1': 9,
    '2.2': 10,
    '3': 11,
    '3.1': 11,
    '3.2': 12,
    '4': 14,
    '4.1': 14,
    '4.2': 15,
    '4.3': 16,
    '4.4': 17,
    '4.5': 20,
    '5': 23,
    '5.1': 23,
    '5.2': 24,
    '5.3': 25,
    '6': 26,
    '6.1': 26,
    '6.2': 28,
    '6.3': 28,
    '7': 30,
    '7.1': 30,
    '7.2': 30,
    '7.3': 31,
    '8': 33,
    '8.1': 33,
    '8.2': 34,
    '8.3': 35,
    '9': 36,
    '9.1': 36,
    '9.2': 37,
    '9.3': 38,
    '9.4': 39,
    '10': 40,
    '10.1': 40,
    '10.2': 41,
    '10.3': 42,
    '10.4': 47,
    '10.5': 50,
    '10.6': 53,
    '10.7': 56,
    '10.8': 57,
    '11': 59,
    '11.1': 59,
    '11.2': 60,
    '11.3': 62,
    '12': 63,
    '12.1': 63,
    '12.2': 64,
    '12.3': 65,
    '13': 67,
    '13.1': 67,
    '13.2': 68,
    '13.3': 69,
    '13.4': 69,
    '14': 70,
    '14.1': 70,
    '14.2': 72,
    '14.3': 74,
    '14.4': 77,
    '14.5': 77,
    '15': 80,
  },
  JAVA: {
    '1': 6,
    '1.1': 6,
    '1.2': 7,
    '1.3': 7,
    '1.4': 8,
    '2': 9,
    '2.1': 9,
    '2.2': 13,
    '3': 14,
    '3.1': 14,
    '3.2': 15,
    '4': 17,
    '4.1': 17,
    '4.2': 18,
    '4.3': 20,
    '4.4': 23,
    '5': 25,
    '5.1': 25,
    '5.2': 26,
    '5.3': 27,
    '6': 28,
    '6.1': 28,
    '6.2': 30,
    '6.3': 31,
    '7': 32,
    '7.1': 32,
    '7.2': 32,
    '7.3': 33,
    '8': 36,
    '8.1': 36,
    '8.2': 38,
    '8.3': 38,
    '9': 40,
    '9.1': 40,
    '9.2': 41,
    '9.3': 42,
    '9.4': 43,
    '10': 44,
    '10.1': 44,
    '10.2': 45,
    '10.3': 46,
    '10.4': 51,
    '10.5': 55,
    '10.6': 58,
    '10.7': 61,
    '10.8': 62,
    '11': 64,
    '11.1': 64,
    '11.2': 65,
    '11.3': 67,
    '12': 68,
    '12.1': 68,
    '12.2': 69,
    '12.3': 70,
    '13': 72,
    '13.1': 72,
    '13.2': 73,
    '13.3': 74,
    '13.4': 74,
    '14': 75,
    '14.1': 75,
    '14.2': 77,
    '14.3': 79,
    '14.4': 82,
    '14.5': 82,
    '15': 85,
  },
  CPH: {
    '1': 13,
    '1.1': 13,
    '1.2': 14,
    '1.3': 16,
    '1.4': 18,
    '1.5': 20,
    '1.6': 25,
    '2': 27,
    '2.1': 27,
    '2.2': 30,
    '2.3': 31,
    '2.4': 31,
    '3': 35,
    '3.1': 35,
    '3.2': 39,
    '3.3': 41,
    '4': 45,
    '4.1': 45,
    '4.2': 47,
    '4.3': 48,
    '4.4': 49,
    '4.5': 51,
    '4.6': 54,
    '5': 57,
    '5.1': 57,
    '5.2': 59,
    '5.3': 60,
    '5.4': 61,
    '5.5': 64,
    '6': 67,
    '6.1': 67,
    '6.2': 68,
    '6.3': 70,
    '6.4': 71,
    '6.5': 72,
    '7': 75,
    '7.1': 75,
    '7.2': 80,
    '7.3': 81,
    '7.4': 82,
    '7.5': 84,
    '7.6': 85,
    '8': 87,
    '8.1': 87,
    '8.2': 89,
    '8.3': 91,
    '9': 93,
    '9.1': 94,
    '9.2': 96,
    '9.3': 99,
    '9.4': 103,
    '10': 105,
    '10.1': 105,
    '10.2': 106,
    '10.3': 108,
    '10.4': 110,
    '10.5': 112,
    '11': 119,
    '11.1': 119,
    '11.2': 123,
    '12': 127,
    '12.1': 127,
    '12.2': 129,
    '12.3': 131,
    '13': 133,
    '13.1': 133,
    '13.2': 136,
    '13.3': 139,
    '14': 143,
    '14.1': 144,
    '14.2': 145,
    '14.3': 147,
    '14.4': 149,
    '15': 151,
    '15.1': 152,
    '15.2': 155,
    '15.3': 157,
    '16': 159,
    '16.1': 159,
    '16.2': 161,
    '16.3': 164,
    '16.4': 165,
    '17': 167,
    '17.1': 168,
    '17.2': 170,
    '18': 173,
    '18.1': 173,
    '18.2': 174,
    '18.3': 177,
    '18.4': 180,
    '19': 183,
    '19.1': 183,
    '19.2': 187,
    '19.3': 188,
    '19.4': 189,
    '20': 191,
    '20.1': 192,
    '20.2': 196,
    '20.3': 197,
    '20.4': 200,
    '21': 207,
    '21.1': 207,
    '21.2': 211,
    '21.3': 214,
    '21.4': 215,
    '22': 217,
    '22.1': 218,
    '22.2': 220,
    '22.3': 222,
    '22.4': 224,
    '22.5': 225,
    '23': 227,
    '23.1': 227,
    '23.2': 230,
    '23.3': 232,
    '24': 235,
    '24.1': 235,
    '24.2': 236,
    '24.3': 238,
    '24.4': 240,
    '24.5': 241,
    '25': 245,
    '25.1': 245,
    '25.2': 247,
    '25.3': 248,
    '26': 253,
    '26.1': 253,
    '26.2': 254,
    '26.3': 255,
    '26.4': 257,
    '27': 261,
    '27.1': 262,
    '27.2': 264,
    '27.3': 265,
    '28': 267,
    '28.1': 268,
    '28.2': 271,
    '28.3': 273,
    '28.4': 274,
    '29': 275,
    '29.1': 276,
    '29.2': 278,
    '29.3': 281,
    '29.4': 282,
    '30': 285,
    '30.1': 286,
    '30.2': 287,
    '30.3': 288,
  },
  PAPS: {
    '1': 15,
    '1.1': 16,
    '1.2': 17,
    '1.2.1': 20,
    '1.3': 21,
    '1.4': 22,
    '1.5': 24,
    '1.6': 25,
    '1.7': 26,
    '2': 29,
    '2.1': 30,
    '2.1.1': 30,
    '2.1.2': 31,
    '2.1.3': 31,
    '2.1.4': 31,
    '2.2': 32,
    '2.3': 35,
    '2.4': 41,
    '2.5': 42,
    '2.6': 45,
    '2.7': 48,
    '2.8': 51,
    '2.9': 52,
    '2.10': 55,
    '2.11': 59,
    '2.12': 60,
    '2.13': 61,
    '2.14': 61,
    '2.15': 62,
    '3': 63,
    '3.1': 64,
    '3.1.1': 65,
    '3.2': 67,
    '3.3': 68,
    '3.4': 69,
    '3.5': 70,
    '3.6': 72,
    '3.7': 73,
    '3.7.1': 73,
    '3.7.2': 74,
    '3.7.3': 75,
    '3.8': 76,
    '3.8.1': 76,
    '3.9': 77,
    '3.9.1': 78,
    '3.9.2': 78,
    '3.9.3': 79,
    '3.10': 80,
    '3.11': 80,
    '4': 81,
    '4.1': 98,
    '4.2': 98,
    '5': 99,
    '5.1': 99,
    '5.2': 103,
    '5.2.1': 107,
    '5.3': 110,
    '5.4': 110,
    '5.5': 111,
    '5.6': 112,
    '5.7': 113,
    '6': 115,
    '6.1': 115,
    '6.2': 121,
    '6.3': 121,
    '6.4': 123,
    '6.4.1': 123,
    '6.4.2': 125,
    '6.4.3': 125,
    '6.5': 126,
    '6.5.1': 127,
    '6.5.2': 128,
    '6.6': 132,
    '7': 135,
    '7.1': 135,
    '7.2': 136,
    '7.3': 140,
    '7.4': 147,
    '7.5': 150,
    '7.6': 152,
    '8': 153,
    '8.1': 153,
    '8.2': 155,
    '8.3': 157,
    '8.4': 160,
    '9': 161,
    '9.1': 162,
    '9.2': 164,
    '9.2.1': 165,
    '9.2.2': 166,
    '9.3': 167,
    '9.4': 170,
    '9.5': 171,
    '9.6': 174,
    '9.6.1': 174,
    '9.6.2': 176,
    '9.6.3': 177,
    '9.7': 180,
    '10': 181,
    '10.1': 181,
    '10.2': 189,
    '10.3': 191,
    '10.3.1': 194,
    '10.3.2': 196,
    '10.3.3': 197,
    '10.4': 200,
    '10.5': 202,
    '11': 203,
    '11.1': 203,
    '11.2': 207,
    '11.2.1': 207,
    '11.2.2': 208,
    '11.2.3': 210,
    '11.3': 213,
    '12': 215,
    '12.1': 215,
    '12.2': 221,
    '12.3': 224,
    '12.3.1': 225,
    '12.3.2': 225,
    '12.3.3': 227,
    '12.4': 228,
    '12.5': 231,
    '13': 233,
    '13.1': 233,
    '13.2': 236,
    '13.2.1': 236,
    '13.2.2': 238,
    '13.3': 239,
    '13.4': 242,
    '14': 243,
    '14.1': 243,
    '14.2': 249,
    '14.3': 253,
    '14.3.1': 260,
    '14.3.2': 262,
    '14.4': 264,
    '15': 265,
    '15.1': 265,
    '15.2': 269,
    '15.2.1': 270,
    '15.3': 276,
    '15.4': 277,
    '15.4.1': 281,
    '15.4.2': 284,
    '15.5': 286,
    '15.6': 289,
    '15.7': 291,
    '15.8': 296,
    '16': 297,
    '16.1': 297,
    '16.2': 301,
    '16.3': 306,
    '16.4': 313,
    '16.5': 316,
    '16.6': 319,
    '16.7': 324,
    '17': 325,
    '17.1': 325,
    '17.1.1': 326,
    '17.1.2': 328,
    '17.2': 329,
    '17.2.1': 329,
    '17.2.2': 332,
  },
  CP2: {
    '1': 17,
    '1.1': 17,
    '1.2': 18,
    '1.2.1': 20,
    '1.2.2': 21,
    '1.2.3': 24,
    '1.2.4': 26,
    '1.2.5': 28,
    '1.2.6': 28,
    '1.3': 29,
    '1.4': 35,
    '2': 37,
    '2.1': 37,
    '2.2': 38,
    '2.2.1': 38,
    '2.2.2': 42,
    '2.3': 45,
    '2.3.1': 45,
    '2.3.2': 46,
    '2.3.3': 48,
    '2.3.4': 51,
    '2.4': 54,
    '3': 55,
    '3.1': 55,
    '3.2': 55,
    '3.2.1': 56,
    '3.2.2': 57,
    '3.3': 63,
    '3.3.1': 63,
    '3.4': 67,
    '3.4.1': 67,
    '3.5': 71,
    '3.5.1': 71,
    '3.5.2': 77,
    '3.5.3': 82,
    '3.6': 86,
    '4': 87,
    '4.1': 87,
    '4.2': 87,
    '4.2.1': 87,
    '4.2.2': 88,
    '4.2.3': 89,
    '4.2.4': 90,
    '4.2.5': 91,
    '4.2.6': 92,
    '4.2.7': 92,
    '4.2.8': 93,
    '4.2.9': 96,
    '4.3': 100,
    '4.3.1': 100,
    '4.3.2': 100,
    '4.3.3': 101,
    '4.3.4': 102,
    '4.4': 106,
    '4.4.1': 106,
    '4.4.2': 106,
    '4.4.3': 107,
    '4.4.4': 109,
    '4.5': 112,
    '4.5.1': 112,
    '4.5.2': 112,
    '4.5.3': 114,
    '4.6': 117,
    '4.6.1': 117,
    '4.6.2': 117,
    '4.6.3': 118,
    '4.6.4': 120,
    '4.7': 123,
    '4.7.1': 123,
    '4.7.2': 128,
    '4.7.3': 129,
    '4.7.4': 130,
    '4.8': 135,
    '5': 137,
    '5.1': 137,
    '5.2': 137,
    '5.3': 141,
    '5.3.1': 141,
    '5.3.2': 142,
    '5.4': 145,
    '5.4.1': 145,
    '5.4.2': 146,
    '5.4.3': 147,
    '5.4.4': 147,
    '5.5': 149,
    '5.5.1': 149,
    '5.5.2': 151,
    '5.5.3': 152,
    '5.5.4': 152,
    '5.5.5': 153,
    '5.5.6': 154,
    '5.5.7': 156,
    '5.5.8': 157,
    '5.5.9': 158,
    '5.6': 158,
    '5.7': 159,
    '5.7.1': 159,
    '5.7.2': 159,
    '5.8': 161,
    '5.8.1': 161,
    '5.8.2': 162,
    '5.8.3': 162,
    '5.9': 163,
    '5.9.1': 163,
    '5.9.2': 164,
    '5.10': 165,
    '6': 167,
    '6.1': 167,
    '6.2': 167,
    '6.3': 169,
    '6.4': 172,
    '6.4.1': 172,
    '6.4.2': 172,
    '6.4.3': 174,
    '6.5': 176,
    '6.5.1': 176,
    '6.5.2': 177,
    '6.5.3': 178,
    '6.6': 179,
    '6.6.1': 179,
    '6.6.2': 179,
    '6.6.3': 180,
    '6.6.4': 182,
    '6.6.5': 186,
    '6.7': 190,
    '7': 191,
    '7.1': 191,
    '7.2': 192,
    '7.2.1': 192,
    '7.2.2': 193,
    '7.2.3': 197,
    '7.2.4': 199,
    '7.2.5': 201,
    '7.2.6': 202,
    '7.2.7': 203,
    '7.3': 204,
    '7.3.1': 204,
    '7.3.2': 204,
    '7.3.3': 204,
    '7.3.4': 205,
    '7.3.5': 205,
    '7.3.6': 206,
    '7.3.7': 207,
    '7.4': 211,
    '7.5': 212,
    '8': 213,
    '8.1': 213,
    '8.2': 213,
    '8.2.1': 213,
    '8.2.2': 214,
    '8.2.3': 215,
    '8.2.4': 215,
    '8.2.5': 215,
    '8.2.6': 215,
    '8.3': 219,
    '8.3.1': 219,
    '8.3.2': 220,
    '8.3.3': 220,
    '8.3.4': 220,
    '8.4': 221,
    '8.4.1': 221,
    '8.4.2': 221,
    '8.4.3': 222,
    '8.4.4': 223,
    '8.4.5': 224,
    '8.4.6': 225,
    '8.5': 227,
  },
};
